export const BAR_CHART_RADIUS: [number, number, number, number] = [4, 4, 0, 0];
